import { isEqual } from "lodash";
import { useState } from "react";
import { NotificationStatusQuickFilter } from "./interfaces";

export const useNotificationStatusQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<NotificationStatusQuickFilter>({
    notificationStatus: { isNotified: null },
  });

  const handleChangeQuickFilter = (
    filter: keyof NotificationStatusQuickFilter,
    value: NotificationStatusQuickFilter["notificationStatus"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    notificationStatusQuickFilter: quickFilter,
    setNotificationStatusQuickFilter: handleChangeQuickFilter,
  };
};
